export var StudyPackButtonTitle;

(function (StudyPackButtonTitle) {
  StudyPackButtonTitle["StudyPack"] = "Study Pack";
  StudyPackButtonTitle["StudyPackLive"] = "Study Pack Live";
})(StudyPackButtonTitle || (StudyPackButtonTitle = {}));

export var StudyPackButtonTestId;

(function (StudyPackButtonTestId) {
  StudyPackButtonTestId["StudyPack"] = "studyPack-onboarding-button";
  StudyPackButtonTestId["StudyPackIcon"] = "studyPack-onboarding-icon";
  StudyPackButtonTestId["StudyPackLive"] = "studyPackLive-onboarding-button";
})(StudyPackButtonTestId || (StudyPackButtonTestId = {}));